import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center pb-10 space-y-10 lg:mx-52" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "Admin Archive", -1)

import ScorecardImageCard from '@/components/Scorecard/ScorecardImageCard.vue';
import { useScorecardStore } from '@/store/scorecards';
import { Scorecard } from '@/typings/scorecard';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const scorecardStore = useScorecardStore();

function inactiveEvent(scorecard: Scorecard) {
  const isInactive = ['Finalising'].includes(scorecard.Status);
  const recentlyClosed = scorecard.Status === 'Closed';

  if (fixableOnly.value) {
    return scorecard.IsChampionshipEligible == null;
  }

  return isInactive || recentlyClosed;
}

const fixableOnly = ref(false);

const events = computed(() => {
  const nextEvents = scorecardStore.scorecards.filter(inactiveEvent);
  return nextEvents.sort(
    (a, b) => Date.parse(b.LocksAt) - Date.parse(a.LocksAt)
  );
});

onMounted(() => {
  scorecardStore.getScorecards();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, "Showing " + _toDisplayString(_unref(events).length), 1),
    _createVNode(_component_Button, {
      label: "Toggle Fixable Only",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (fixableOnly.value = !fixableOnly.value))
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(events), (scorecard) => {
      return (_openBlock(), _createBlock(ScorecardImageCard, {
        key: scorecard.Slug,
        scorecard: scorecard,
        fixable: scorecard.IsChampionshipEligible == null
      }, null, 8, ["scorecard", "fixable"]))
    }), 128))
  ]))
}
}

})